import { SecondaryButton } from "components/designV2/buttons/secondaryButton";
import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";
import { CircularProgress } from "@material-ui/core";
import styled from "styled-components";

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(8, 18, 30, 0.45);
  display: flex;
  justify-content: flex-end;
  z-index: 3200;
`;

export const Panel = styled.div`
  width: 520px;
  max-width: 95vw;
  height: 100%;
  max-height: 100dvh;
  background: ${ColorV2.Blue7};
  box-shadow: -12px 0 32px rgba(15, 42, 64, 0.2);
  padding: 34px 22px 20px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  overflow: hidden;
`;

export const PanelBody = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-right: 12px;
  margin-right: -12px;
  scrollbar-width: thin;
  scrollbar-color: ${ColorV2.Blue5} transparent;

  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: ${ColorV2.Blue5};
    border-radius: 999px;
    border: 2px solid transparent;
    background-clip: content-box;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: ${ColorV2.Blue4};
    background-clip: content-box;
  }
`;

export const PanelContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const StickyFooter = styled.div`
  position: sticky;
  bottom: 0;
  z-index: 1;
  margin-top: auto;
  padding: 24px 0 10px;
  background: linear-gradient(
    to bottom,
    rgba(242, 246, 249, 0) 0%,
    ${ColorV2.Blue7} 30%
  );
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

export const Title = styled.h2`
  ${TypographyV2.h2};
  color: ${ColorV2.Blue1};
  margin: 0;
`;

export const CloseButton = styled(SecondaryButton)`
  flex-shrink: 0;
`;

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const SectionHeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

export const SectionHeaderLeft = styled.div`
  display: inline-flex;
  align-items: baseline;
  gap: 10px;
`;

export const SectionTitle = styled.h3`
  ${TypographyV2.b1};
  color: ${ColorV2.Blue1};
  margin: 0;
`;

export const SectionMeta = styled.span`
  ${TypographyV2.s1};
  color: ${ColorV2.Blue4};
  white-space: nowrap;
`;

export const DataCard = styled.div`
  position: relative;
  border-radius: 12px;
  background: ${ColorV2.White};
  padding: 14px 14px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const DataCardLoadingOverlay = styled.div`
  position: absolute;
  inset: 0;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.72);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
`;

export const LoadingSpinner = styled(CircularProgress).attrs({
  size: 28,
})`
  color: ${ColorV2.Blue1};
`;

export const KeyValueRow = styled.div`
  display: grid;
  grid-template-columns: minmax(90px, 1fr) minmax(120px, 1fr);
  align-items: center;
  gap: 12px;
`;

export const InlineFieldGroup = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
`;

export const InlineFieldLabel = styled.span`
  ${TypographyV2.b2};
  color: ${ColorV2.Blue3};
`;

export const TimePickerWrap = styled.span`
  width: 115px;
  display: inline-flex;
`;

export const KeyLabel = styled.span`
  ${TypographyV2.b2};
  color: ${ColorV2.Blue3};
`;

export const Value = styled.span`
  ${TypographyV2.b1};
  color: ${ColorV2.Blue1};
  text-align: right;
`;

export const ValueWithChip = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
`;

export const OvertimeChip = styled.span`
  ${TypographyV2.s1};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border-radius: 999px;
  min-height: 24px;
  padding: 4px 10px;
  color: ${ColorV2.NegativeRed};
  background: #fce9e9;
  white-space: nowrap;
`;

export const MutedValue = styled(Value)`
  color: ${ColorV2.Blue4};
`;

export const Divider = styled.hr`
  width: 100%;
  border: none;
  border-top: 1px solid #d9e5ef;
  margin: 0;
`;

export const CommentCard = styled.div`
  border-radius: 12px;
  background: ${ColorV2.Blue6};
  padding: 14px 14px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const CommentTitle = styled.span`
  ${TypographyV2.b2};
  color: ${ColorV2.Blue1};
`;

export const CommentText = styled.span`
  ${TypographyV2.b2};
  color: ${ColorV2.Blue1};
`;

export const Footer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
`;

export const EditFooter = styled.div`
  display: flex;
  justify-content: center;
  gap: 12px;
`;

export const FeedbackBodyText = styled.p`
  ${TypographyV2.b2};
  color: ${ColorV2.Blue1};
  margin: 0;
  text-align: center;
`;

export const StatusBannerLoadingWrap = styled.div`
  width: 100%;
  min-height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: ${ColorV2.White};
`;

export const CompactStatusBanner = styled.div<{
  $textColor: ColorV2;
  $backgroundColor: string;
}>`
  width: 100%;
  min-height: 52px;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  border-radius: 12px;
  background: ${(props) => props.$backgroundColor};
  color: ${(props) => props.$textColor};
`;

export const CompactStatusBannerLabel = styled.span`
  ${TypographyV2.b2};
  line-height: 1.2;
`;
